<template>
  <div
    v-if="loaded"
    class="content-devx main-dx-work-order-edit"
  >
    <f7-block
      class="content-planning-resume"
      name="order"
    >
      <label>{{ $t("WorkOrderDetail_order") }}</label>
      <span>{{ actualWorkOrder.taskCode }}</span>
      <span>{{ actualWorkOrder.Date.toString() }}</span>
      <span>({{ actualWorkOrder.taskCode }}){{ actualWorkOrder.Task }}</span>
      <span>({{ actualWorkOrder.activityCode }}){{ actualWorkOrder.Activity }}</span>
    </f7-block>
    <f7-row>
      <f7-col width="30">
        <DxTreePlanning
          :locations-tree="locationsTree"
          :location-selected="actualWorkOrder.location"
          :show-grouped="false"
          :locations-completed="actualWorkOrder.locations_tree"
        />
      </f7-col>
      <f7-col width="70">
        <f7-row class="block content-devx">
          <f7-col>
            <f7-block-title
              class="no-padding-top"
              name="select_supervisor"
            >
              {{ $t("WorkOrderDetail_select_supervisor") }}:
            </f7-block-title>
            <DxSelectSupervisorGrouped
              :locations="actualWorkOrder.location"
              :locations-tree="locationsTree"
              :supervisors-availables="supervisorsAvailables"
              :supervisors-location="[{ supervisor: actualWorkOrder.responsible, location: actualWorkOrder.location}]"
            />
            <f7-block-title
              class="no-padding-top"
              name="select_date"
            >
              {{ $t("WorkOrderDetail_select_date") }}:
            </f7-block-title>
            <DxSelectDate
              :actual-date="actualWorkOrder.Date"
            />
          </f7-col>
        </f7-row>
        <f7-row class="block content-devx">
          <f7-col>
            <f7-block-title
              class="no-padding-top"
              name="additional_info"
            >
              {{ $t("WorkOrderDetail_additional_info") }}:
            </f7-block-title>
            <DxAdditionalInfo
              :actual-additional-info="actualWorkOrder.additionalInfoWorkOrder"
            />
          </f7-col>
        </f7-row>
        <f7-row
          v-if="actualWorkOrder.itemsDriversWorkOrder.length !== 0"
          class="block content-devx"
        >
          <f7-col>
            <f7-block-title>
              {{ $t('WorkOrderDetail_select_driver') }}:
            </f7-block-title>
            <DxSelectItemsDriver
              :items-planning="actualWorkOrder.itemsTypes"
              :items-availables="itemsAvailables"
              :items-work-order-selected="actualWorkOrder.itemsDriversWorkOrder"
              :items-drivers-work-order-selected="actualWorkOrder.itemsDriversWorkOrder"
              :drivers-availables="driversAvailables"
            />
          </f7-col>
        </f7-row>
        <f7-row
          v-if="actualWorkOrder.Attachments.length !== 0"
          class="block content-devx"
        >
          <f7-col>
            <f7-block-title>
              {{ $t('DxAttachment_Title') }}:
            </f7-block-title>
            <DxAttachmentMachinaryTable
              :attachment-list="attachmentList"
              :items-planning="actualWorkOrder.Attachments"
              :items-work-order-selected="actualWorkOrder.itemsDriversWorkOrder"
              :machinary-availables="itemsAvailables"
            />
          </f7-col>
        </f7-row>
        <f7-row
          v-if="actualWorkOrder.ToolsDetailTab && actualWorkOrder.ToolsDetailTab.length > 0"
          class="block content-devx"
        >
          <f7-col>
            <f7-block-title>
              {{ $t('DxTools_Title') }}:
            </f7-block-title>
            <DxToolsTable
              :tools-types-availables="toolList"
              :tools-availables="typesTool"
              :planning="actualWorkOrder"
              :allow-updating="false"
              :allow-deleting="false"
              :allow-adding="false"
              :is-post-work="false"
              :is-work-order-create="true"
              :is-edit-work-order="true"
            />
          </f7-col>
        </f7-row>
        <f7-row
          v-if="actualWorkOrder.Planner && actualWorkOrder.Planner.products.length > 0"
          class="block content-devx"
        >
          <f7-col>
            <f7-block-title>
              {{ $t('DxProducts_Title') }}:
            </f7-block-title>
            <DxPlanningProducts
              :read-only="true"
            />
          </f7-col>
        </f7-row>
        <f7-row
          v-if="actualWorkOrder.binsDetail.length !== 0"
          class="block content-devx"
        >
          <f7-col>
            <f7-block-title>
              {{ $t('DxNursery_Title') }}
            </f7-block-title>
            <DxBinsContentGridPlanning />
          </f7-col>
        </f7-row>
      </f7-col>
    </f7-row>
  </div>
</template>

<script>
import DxSelectItemsDriver from './DxSelectItemsDriver.vue';
import DxSelectSupervisorGrouped from './DxSelectSupervisorGrouped.vue';
import DxSelectDate from './DxSelectDate.vue';
import DxAdditionalInfo from './DxAdditionalInfo.vue';
import DxTreePlanning from '../DxTreePlanning.vue';
import DxPlanningProducts from '../Planning/DxPlanningProducts.vue';
import DxToolsTable from '../Planning/DxToolsTable.vue';
import DxAttachmentMachinaryTable from './DxAttachmentMachinaryTable.vue';
import DxBinsContentGridPlanning from '../greenhouse/DxBinsContentGridPlanning.vue';
import Api from '../../services/Api';

export default {
  name: 'DxWorkOrderEdit',
  components: {
    DxSelectItemsDriver,
    DxSelectSupervisorGrouped,
    DxSelectDate,
    DxAdditionalInfo,
    DxTreePlanning,
    DxPlanningProducts,
    DxToolsTable,
    DxAttachmentMachinaryTable,
    DxBinsContentGridPlanning,
  },
  props: {
    actualWorkOrder: { type: Object, default: () => {} },
  },
  data() {
    return {
      loaded: false,
      supervisorsAvailables: [],
      locationsTree: [],
      itemsAvailables: [],
      itemsWorkOrder: [],
      DxTreePlanning,
      actualAdditionalInfo: '',
      toolList: [],
      driversAvailables: [],
      attachmentList: [],
      typesTool: [],
    };
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      // Cargamos attachment y vehiculos
      let xhr = await Api.getDataSubfamilyByType('machinery');
      const machineryAttachment = JSON.parse(xhr.response);
      this.setDataAttachment(machineryAttachment);
      this.locationsTree = await this.loadLocationsTree();
      this.supervisorsAvailables = await this.getSupervisors();
      // this.itemsAvailables = await this.getItems('VEHICLE');
      this.driversAvailables = await this.getEmployeesDriver();
      xhr = await Api.getDataSubfamilyByType('tool');
      const dataTools = JSON.parse(xhr.response);
      this.setDataTool(dataTools);
    } catch (error) {
      const message = this.$helpers.getFilteredErrorMessage(error);
      if (message.includes('default_') && !message.includes('404')) {
        this.$f7.dialog.alert(message.split('_').pop());
      } else if (!message.includes('404')) {
        this.$f7.dialog.alert(this.$t(message));
      }
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },

  methods: {
    async loadLocationsTree() {
      const xhr = await Api.getLocationsTree();
      return JSON.parse(xhr.response);
    },
    async getSupervisors() {
      const xhr = await Api.getSupervisors();
      return JSON.parse(xhr.response).data;
    },
    async getItems(type, family) {
      const xhr = await Api.getItems(type, family);
      return JSON.parse(xhr.response);
    },
    async getEmployeesDriver() {
      const xhr = await Api.getEmployees();
      return JSON.parse(xhr.response).data.filter((employee) => employee.driver === true);
    },
    isDriver(empleado) {
      for (let i = 0; i < empleado.properties.length; i += 1) {
        if (empleado.properties[i].key === 'drive') {
          return empleado.properties[i].value;
        }
      }
      return 'False';
    },
    setDataAttachment(dataMachinaryAttachments) {
      this.itemsAvailables.length = 0;
      this.attachmentList.length = 0;
      for (let i = 0; i < dataMachinaryAttachments.length; i += 1) {
        if (dataMachinaryAttachments[i].id === 'VEHICLE') {
          for (let j = 0; j < dataMachinaryAttachments[i].items.length; j += 1) {
            this.itemsAvailables.push(dataMachinaryAttachments[i].items[j]);
          }
        } else if (dataMachinaryAttachments[i].id === 'ATTACHMENT') {
          for (let j = 0; j < dataMachinaryAttachments[i].items.length; j += 1) {
            this.attachmentList.push(dataMachinaryAttachments[i].items[j]);
          }
        }
      }
    },
    setDataTool(tools) {
      this.toolList.length = 0;
      for (let i = 0; i < tools.length; i += 1) {
        if (tools[i].id === 'TOOL') {
          for (let j = 0; j < tools[i].items.length; j += 1) {
            for (let k = 0; k < tools[i].items[j].items.length; k += 1) {
              if (tools[i].items[j].items.length > 0) {
                this.toolList.push({
                  name: tools[i].items[j].id,
                  id: tools[i].items[j].items[k].item,
                });
              }
              this.typesTool.push({
                id: tools[i].items[j].items[k].id,
                description: tools[i].items[j].items[k].description,
                item: tools[i].items[j].items[k].item,
              });
            }
          }
          break;
        }
      }
    },
  },
};
</script>

<style>

</style>
